import React from 'react';
import { RegistrationProgress } from '../organisms/registration/RegistrationProgress';
import { px } from 'csx';
import { classes, style } from 'typestyle';
import { SignUpForm } from '../molecules/SignUpForm';
import { rebrand } from '../../../theme/color';
import { minBodyHeight } from '../config';
import { heading2 } from '../utilities/font';
import { Component, ComponentProps, deps, inject, observer } from '../../../lib/component';
import { AnalyticsController } from '../../../modules/analytics/controller';
import { LOG_IN_ROUTE } from '../../../constants';
import { spacing } from '../../../theme/spacing';
import { Link } from '../atoms/Link';
import { Accreditations } from '../molecules/Accreditations';
import { LoginContent } from '../templates/LoginContent';

const styles = {
  wrapper: style({
    minHeight: minBodyHeight,
    display: 'grid',
    gridTemplateRows: 'max-content 1fr',
  }),
  panelHeading: style(heading2, {
    marginTop: spacing.XLARGE,
  }),
  panelText: style({
    margin: `${spacing.DEFAULT} 0 0`,
    fontSize: px(20),
  }),
  logInPrompt: style({
    color: rebrand.contrast[40].toString(),
    marginTop: spacing.DEFAULT,
    marginBottom: 0,
    fontSize: px(12),
    $nest: {
      '& a': {
        textDecoration: 'underline',
        color: rebrand.contrast[50].toString(),
      },
    },
  }),
};

const sendClickLoginEvent = (analytics: AnalyticsController) =>
  analytics.sendMixpanel('User clicks log in prompt', { path: '/sign-up' });

@inject(deps)
@observer
export class SignUp extends Component<ComponentProps> {
  render() {
    const {
      controller: { analytics },
    } = this.props;
    return (
      <div className={classes(styles.wrapper)}>
        <RegistrationProgress step={0} />
        <LoginContent>
          <Accreditations />

          <h1 className={classes(styles.panelHeading)}>Ready for better music?</h1>

          <p className={styles.panelText}>
            Sign up with your <strong>YouTube channel</strong> so we can calculate your pricing fairly based on your
            channel size. You can add or change channels later.
          </p>

          <SignUpForm />

          <p className={styles.logInPrompt}>
            Or{' '}
            <Link href={LOG_IN_ROUTE} onClick={() => sendClickLoginEvent(analytics)}>
              log in
            </Link>{' '}
          </p>
        </LoginContent>
      </div>
    );
  }
}
